import Config from "src/Constants/Config";

import useClock from "src/Hooks/useClock";
import profiles from "../../../Component/TV/profiles.json";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Pulse from "src/Component/Pulse";
import ProfileAndTime from "src/Component/ProfileAndTime";
// import PageVideo from "src/Component/TV/HomePage/PageVideo";

import "./index.sass";

interface ScreenProps {
  step: number;
  setStep: (step: number) => void;
  pageId: number;
}

const Screen = ({ step, setStep, pageId }: ScreenProps) => {
  const baseImages = `${Config.BASE_URL}/images/screen_${pageId}/`;
  const imgBgScreen = `${baseImages}bg.jpg`;
  // const baseVideoURL = `${Config.BASE_URL}/videos/`;

  const currentUser = useSelector(() => store.getState().appReducer.currentUser);

  const time = useClock();

  const currentProfile = profiles.find((profile) => profile.key === currentUser);

  const handleOnclickPulse = () => setStep(2);

  // const [optionChosen, setOptionChosen] = useState<number | null>(null);

  // useEffect(() => {
  //   if (step === 2) setTimeout(() => setStep(3), 800);
  //   if (step === 4) setTimeout(() => setStep(5), 600);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [step]);

  const tvStyle = { position: "absolute" as "absolute", transition: "opacity 0.5s", top: 0, left: 0, width: "100%", height: "100%" };

  return (
    <>
      <ProfileAndTime bg={imgBgScreen} time={time} currentProfile={currentProfile} />
      <div
        style={{
          position: "absolute",
          left: "var(--width-150)",
          width: "var(--width-150)",
          height: "var(--height-450)",
          zIndex: 100,
          transition: "all 0.5s ease",
          opacity: step === 2 ? 1 : 0,
          bottom: step === 2 ? "var(--width-35)" : "-100px",
        }}
      >
        <img style={{ width: "100%" }} src={`${Config.BASE_URL}/images/screen_6/control.png`} alt="" />
      </div>
      <img style={{ ...tvStyle, opacity: step >= 2 ? 1 : 0, zIndex: step >= 2 ? 10 : -1 }} src={`${baseImages}tv_1.jpg`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 3 ? 1 : 0, zIndex: step >= 3 ? 10 : -1 }} src={`${baseImages}tv_2.jpg`} alt="" />
      <img style={{ ...tvStyle, opacity: step >= 4 ? 1 : 0, zIndex: step >= 4 ? 10 : -1 }} src={`${baseImages}tv_3.jpg`} alt="" />

      <div className="screen-9-btn-1" onClick={() => (step === 2 ? setStep(3) : null)}>
        {step === 2 && <Pulse style={{ width: "var(--width-55)" }} />}
      </div>
      <div className="screen-9-btn-2" onClick={() => (step === 3 ? setStep(4) : null)}>
        {step === 3 && <Pulse style={{ width: "var(--width-55)" }} />}
      </div>

      <div className="screen-9-modal">
        <Pulse style={{ position: "absolute", top: "var(--height-350)", right: "var(--width-55)" }} />
        <div className="screen-9-modal-btn-pulse" onClick={handleOnclickPulse}></div>
      </div>
    </>
  );
};

export default Screen;
